export default "__VITE_ASSET__63b04d3f__"